var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4-5h24v24H-4z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.826 5.76c.676 0 1.224.56 1.224 1.25a1.24 1.24 0 0 1-1.099 1.244l-.125.007H2.074C1.398 8.26.85 7.7.85 7.01c0-.647.482-1.18 1.099-1.244l.125-.006h11.752ZM13.826.76c.676 0 1.224.56 1.224 1.25a1.24 1.24 0 0 1-1.099 1.244l-.125.007H2.074C1.398 3.26.85 2.7.85 2.01c0-.647.482-1.18 1.099-1.244l.125-.006h11.752ZM13.826 10.76c.676 0 1.224.56 1.224 1.25a1.24 1.24 0 0 1-1.099 1.244l-.125.007H2.074c-.676 0-1.224-.56-1.224-1.25 0-.647.482-1.18 1.099-1.244l.125-.006h11.752Z"
})))));
export default SvgMenu;